import { render, staticRenderFns } from "./single-button.vue?vue&type=template&id=74b26da9&scoped=true&"
import script from "./single-button.vue?vue&type=script&lang=js&"
export * from "./single-button.vue?vue&type=script&lang=js&"
import style0 from "./single-button.vue?vue&type=style&index=0&id=74b26da9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74b26da9",
  null
  
)

export default component.exports